import { SensorData } from 'Simulations/SensorPoint';
import { FilterStage, StageParameters } from '../../Stage';
import Grid from 'Geodata/grid';

export type SliceStageParameters = StageParameters & {
    slicex: [number, number];
    slicey: [number, number];
    slicez: [number, number];
};

export class SliceStage extends FilterStage<SliceStageParameters> {
    protected filter(sensorData: SensorData): boolean {
        const sensorPoint = sensorData.getSensorPoint();
        const index = sensorPoint.index;
        const floor = sensorPoint.getFloor();

        const [x, y] = Grid.indexToXYZ(index);

        const isSliceXInside = (x: number) => x >= this.getParams().slicex[0] - 1 && x <= this.getParams().slicex[1] - 1;
        const isSliceYInside = (y: number) => y >= this.getParams().slicey[0] - 1 && y <= this.getParams().slicey[1] - 1;
        const isSliceZInside = (z: number) => z >= this.getParams().slicez[0] && z <= this.getParams().slicez[1];

        return isSliceXInside(x) && isSliceYInside(y) && isSliceZInside(floor);
    }
}
